import 'firebase/firestore'
import 'firebase/auth'
import {
	db
} from '../resources/firebase'

/**
 * Gets all auth user's notifications and saves them to the vuex store
 * @param {Object} store - Vuex store object
 */
export function getNotifications(store) {
	return new Promise((resolve, reject) => {
		let unseenNotifs = []
		let ref = db.collection("test_notifications").doc(store.state.user.authUser.uid)
			.collection('notifications')
			.where("seen", "==", false)
			.orderBy("dateCreated", "desc")

		ref.onSnapshot({
			includeMetadataChanges: true
		}, snapshot => {
			snapshot.docChanges().forEach((change) => {
				if (change.type === 'added' && change.doc.data().hasOwnProperty('id')) {
					unseenNotifs.push(change.doc.data())
					store.commit('addNotifications', unseenNotifs)
				} else if (change.type === 'modified' && change.doc.data().hasOwnProperty('id')) {
					unseenNotifs.push(change.doc.data())
					store.commit('addNotifications', unseenNotifs)
				}
			})
		})

		resolve()
	})
}

/**
 * Sends notification to user
 * @param {String} targetUser - User's userID who will recveive the notification
 * @param {Object} notification - The notification the targetUser will recieve
 */
export function sendNotification(targetUser, notification) {
	return new Promise((resolve, reject) => {
		db.collection("test_notifications").doc(targetUser)
			.collection('notifications').add(notification)
			.then((docRef) => {
				db.collection("test_notifications").doc(targetUser)
					.collection('notifications').doc(docRef.id)
					.update({
						"id": docRef.id
					})
					.then(() => {
						resolve()
					})
					.catch((error) => {
						// console.log(error)
						reject(new Error(error))
					})
			})
			.catch((error) => {
				// console.log(error)
				reject(new Error(error))
			})
	})
}



// WEBPACK FOOTER //
// ./src/api/notifications.js